import { SelectedSystemType } from 'data/types';
import { isDuctedCompatibilitySystem } from 'utils/ducted-quote-layout';
import { isPtacSelectedSystem } from 'utils/ptac-selected-system';

// Compatibility systems and Hotel Style PTAC systems both accessorize
// through the server's ducted rules (PTAC: wall sleeve, exterior grille,
// drain kit, control per unit) — no line sets or mini-split wire.
export function usesDuctedAccessoryRules(
  system: Pick<SelectedSystemType, 'tags'>
): boolean {
  return isDuctedCompatibilitySystem(system) || isPtacSelectedSystem(system);
}
